/**
 * Tasks page component
 */


import { Header } from '../components/layout/Header';
import TasksTab from '../components/TasksTab';

function TasksPage() {
  return (
    <div className='min-h-screen bg-gray-50'>
      <Header />
      <main className='w-full py-6 sm:px-6 lg:px-8'>
        <div className='px-4 py-6 sm:px-0'>
          <TasksTab />
        </div>
      </main>
    </div>
  );
}

export default TasksPage;
